import { useAppSelector } from '@hooks/redux.hooks';
import { AVAILABLE_LANGUAGES } from '@redux/settings/settings.reducer';
import { selectLanguage } from '@redux/settings/settings.selectors';
import { flattenMessages, getSettingsLocale } from '@utils/locale.utils';
import { ReactNode } from 'react';
import { IntlProvider } from 'react-intl';

import messages_en from './en.json';
import messages_fr from './fr.json';
import { IntlGlobalProvider } from './IntlGlobalProvider';

type Props = {
  children?: ReactNode;
};

export const messages: {
  [key in Exclude<AVAILABLE_LANGUAGES, AVAILABLE_LANGUAGES.browser>]: Record<string, string>;
} = {
  [AVAILABLE_LANGUAGES.fr]: flattenMessages(messages_fr),
  [AVAILABLE_LANGUAGES.en]: flattenMessages(messages_en),
};

export default function MessagesProvider({ children }: Readonly<Props>) {
  const settingsLanguage = useAppSelector(selectLanguage);
  const locale = getSettingsLocale(settingsLanguage);

  return (
    <IntlProvider locale={locale} messages={messages[locale]}>
      <IntlGlobalProvider>{children}</IntlGlobalProvider>
    </IntlProvider>
  );
}
